import React from "react";
import { useDispatch, useSelector } from "react-redux"//Hooks de redux
import { useNavigate, useLocation } from 'react-router-dom'
import { Typography, useTheme } from '@mui/material'
// import icnMrk from '../../assets/ico-person_pin_circle.png'
// import { mainStyles, theme } from '../../styles'
// import { useStyles } from "./EvidenceStyles"; //Estílos específicos de los elementos de este componente
import { fileActions, documentsActions } from '../../store/actions'//Acciones de redux necesarioas en el stage
import { CustomLoadingOverlay, CustomMainContainer, Buttons, GeoLocationGeneric} from '../../components'
import { evidenceFunctions } from "./EvidenceFunctions";
import { coreFunctions } from '../../utils'//Funciones genéricas
import GeoLocation from '../../components/GeoLocation'
import { useTranslation } from 'react-i18next';

export default function LocationEAudioComponent(props) {
  const theme = useTheme()
    const location = useLocation()
  const { useState, useEffect } = React;
  const gridContainer = {} //mainStyles.gridStyle();
  const navigate = useNavigate()
  const localStyles = {}//useStyles(); //estílos de este componente (PolicyStyles.js)
  const [lat, setLat] = useState("");
  const [lon, setLon] = useState("");
  const [map, setMap] = useState("");
  const [fileId, setFileId] = useState(false)
  const [audiob64, setAudiob64] = useState([])
  const [isFirstLoad, setFirstLoad] = useState(true);

  const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader  
  const [activeAudioEvidence, setActiveAudioEvidence] = useState("0")
  const [activeVideoEvidence, setActiveVideoEvidence] = useState("0")
  const [marqueeText, setMarkeeText] = useState("Instrucciones")
  const [auditoText, setAudioText] = useState("Instrucciones")
  const [evidenceDate, setEvidenceDate] = useState("")
  const [saveContinue, setSaveContinue] = useState(false)
  const [saveAudio, setSaveAudio] = useState(false);
  const [uploadDocSectionContent, setUploadDocSectionContent] = useState(false)
  const [isFlowGroup, setIsFlowGroup] = useState(false)
  const [videob64, setVideob64] = useState([])
  const [nameVideoB64, setNameVideoB64] = useState("");


  const [texSubTittle, setTexSubTittle] = useState('')
  const [activeLocation, setActiveLocation] = useState(false)

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [openErrorTitle, setOpenErrorTitle] = useState("");
  const [openErrorDescription, setOpenErrorDescription] = useState("");

  const { t } = useTranslation();

  //Redux hooks
  const auth = useSelector(state => state.Authentication)
  const file = useSelector(state => state.FileInfo)
  const documentUpEvidence = useSelector(state => state.DocumentUploadEvidence)
  const uploadDocSecContent = useSelector(state => state.UploadDocSectionContent)
  const dispatch = useDispatch()//constate dispatch que ejecutará las acciones

  useEffect(() => {
    console.log("audiob64.---------: ", location.state.audiob64)
    dispatch(fileActions.GetFileInfo(location.state.folioId))
    setFileId(location.state.folioId)
    setAudiob64(location.state.audiob64)
    setAudioText(location.state.textAudio)
    setMarkeeText(location.state.textVideo)
    setEvidenceDate(location.state.dateEvidence)
    setVideob64(location.state.videob64)
    setNameVideoB64(location.state.nameVideo)
    setFirstLoad(true)
    let varFlowGroup = sessionStorage.getItem('isFlowGroup')
    setIsFlowGroup(varFlowGroup)
  }, []);

  useEffect(() => {
    console.log("File: ", file.items)
    setLoadView(file.loading)

    if (file.items != undefined && !isFirstLoad) {
      let actAudioEvidence = file.items.Stage.Properties.find(element => element.Name == "ActiveAudioEvidence")
      let actVideoEvidence = file.items.Stage.Properties.find(element => element.Name == "ActiveVideoEvidence")
      let textSubTitle = file.items.Stage.Properties.find(element => element.Name == "textSubTittle")

      setActiveAudioEvidence(actAudioEvidence?.Value)
      setActiveVideoEvidence(actVideoEvidence?.Value)
      setTexSubTittle(textSubTitle?.Value)
      if (file.items.Product == "Solicitud Grupal") {
        setIsFlowGroup(true)
      }
    } else if (file.items != undefined && saveAudio) {
      if (activeVideoEvidence == "1") {
        let stageName = file.items.Stage.Name
        let stageId = file.items.Stage.Id
        let stage = file.items.Stage
        let folioId = file.items.Id

        let nextComponent = "EvidenceStartComponent"
        console.log("FILEINFO: SAVE Audio----- COntinue ----EVIDECE Video----", file.items, nextComponent)
        evidenceFunctions.doNextStage({ navigate, nextComponent, State: {  stageName, stageId, stage, folioId} })
      } else {
        let stageName = file.items.Stage.Name
        let stageId = file.items.Stage.Id
        let stage = file.items.Stage
        let folioId = file.items.Id
        let nextComponent = coreFunctions.GetLegoNext(stageName)
        console.log("FILEINFO: SNetx Stage------------------: ", nextComponent)
        console.log("FILEINFO: SAVE Audio----- COntinue ", file.items)
        evidenceFunctions.doNextStage({ navigate, nextComponent, State: {  stageName, stageId, stage, folioId} })
      }
    } else if (file.items != undefined) {
      let textSubTitle = file.items?.Stage?.Properties?.find(element => element.Name == "textSubTittle")
      setTexSubTittle(textSubTitle?.Value)
    }

  }, [file])

  useEffect(() => {
    // console.log("Carga de evidencia: Response - ", documentUpEvidence)
    setLoadView(documentUpEvidence.loading)
    if (documentUpEvidence.items != undefined && saveContinue) {
      let documentSectionId = documentUpEvidence.items?.Result?.VideoEvidence?.DocumentSection_Id
      if (documentSectionId != undefined && documentSectionId != null) {
        let requestSecContent = {
          documentSectionId: documentSectionId,
          B64Data: videob64,
          fileName: nameVideoB64,
        }
        console.log(".:UploadDocumentSectionContent:.requestSecContent: ", requestSecContent)
        dispatch(documentsActions.UploadDocumentSectionContent(requestSecContent))

        console.log("uploadDocSecContent: saveAudio ", fileId)
        dispatch(fileActions.GetFileInfo(fileId))
        setSaveAudio(true)
        setSaveContinue(false)
        setUploadDocSectionContent(false)
      } else {
        let stageName = documentUpEvidence.items.Stage.Name
        let stageId = documentUpEvidence.items.Stage.Id
        let stage = documentUpEvidence.items.Stage
        let folioId = fileId
        let nextComponent = coreFunctions.GetLegoNext(stageName)
        console.log("FILEINFO: SNetx Stage------------------: ", nextComponent)
        evidenceFunctions.doNextStage({ navigate, nextComponent, State: {  stageName, stageId, stage, folioId} })
      }
    } else if (documentUpEvidence.error != undefined && saveContinue) {
      console.log(".:UploadDocumentSectionContent:.requestSecContent:Error: ", documentUpEvidence.error)
      setOpenErrorAlert(true)
      setOpenErrorTitle("Error")
      setOpenErrorDescription(documentUpEvidence.error)
      setSaveContinue(false)
      setUploadDocSectionContent(false)
    }
  }, [documentUpEvidence]);

  let handleContinue = () => {

    let audBlob = audiob64?.length > 0 ? audiob64.replace('data:application/octet-stream;base64,', '') : null

    let requestDocEvidence = {
      "ObjectId": fileId,
      "Geolocation": {
        "Latitude": lat,
        "Longitude": lon
      },
      "VideoEvidence": {
        "B64Content": "",
        "Extension": "",
        "DeferLoad": true,
        "SkipActor": (isFlowGroup ? null : true),
      },
      "AudioEvidence": {
        "B64Content": audBlob,
        "Extension": audiob64?.length > 0 ? ".wav" : null
      },
      "LivenessEvidence": {
        "B64Content": "",
        "Extension": "",
        "DeferLoad": false
      },
      "TextVideoEvidence": marqueeText,
      "TextAudioEvidence": auditoText,
      "AudioEvidenceDate": evidenceDate,
      "VideoEvidenceDate": null,
      "TrackingData": {
        "IMEI": "FC:01:7C:45:48:3F",
        "Reference": fileId
      },
      "ContinueWorkFlow": true
    }

    // let requestDocEvidence = {
    //   AudioEvidence: { B64Content: audioData, Extension: ".wav" },
    //   ContinueWorkFlow: true,
    //   ObjectId: fileId,
    //   VideoEvidence: { B64Content: "", Extension: "" },
    //   Geolocation: { Latitude: lat, Longitude: lon },
    //   TextVideoEvidence: marqueeText,
    //   TextAudioEvidence: auditoText,
    //   VideoEvidenceDate: null,
    //   AudioEvidenceDate: evidenceDate,
    //   LivenessEvidence: {
    //     B64Content: "",
    //     Extension: "",
    //     DeferLoad: false,
    //   },
    //   TrackingData: {
    //     IMEI: "FC:01:7C:45:48:3F", // Todo: Este si va MAC o DeviceID
    //     Reference: ""
    //   }
    // }
    console.log("----Request--------Evidence_-------AUDIO----: ", requestDocEvidence)
    dispatch(documentsActions.documentUploadEvidence(requestDocEvidence))
    setSaveContinue(true)
  }

  return (<CustomMainContainer
    oneButton={true}
    body={<div className={localStyles.wid100} >
       <GeoLocationGeneric SuccessFN={(latitude, longitude) => {
        console.log("succes,latitude, longitude ", latitude, longitude);
        setLat(latitude);
        setLon(longitude);
      }}
        ErrorFN={(error) => console.log('error', error)}
      />
      <Typography
        variant="h6"
        gutterBottom
        
          
      >
        {t("confirm_request")}
      </Typography>
      <Typography
        variant="subtitle1"
        gutterBottom
         >
        {texSubTittle}
      </Typography>

      {/* <div id="map" className={localStyles.mapContainer}> */}
      {activeLocation ?
          <GeoLocation
          center={{ lat: parseFloat(lat), lng: parseFloat(lon) }}
          zoom={17}
        /> :
        null}
      {/* </div> */}
    </div>}
    buttons={<Buttons
      className={localStyles.acceptBtn}
      size={100}
      text_color='#ffffff'
      background_color={theme.palette.primary.main}
      // text={textButton}
      text={t("general_next")}
      type='button' click={handleContinue} />}
    externals={<div>
      {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
    </div>}
  />);
}